module.exports = __webpack_public_path__ + "img/party_lower_2.7f6d4ff1.jpg";